<!-- this just wraps whatever is passed in inside app so that vuetify styles and
  theme colors will be applied correctly with vue-custom-component and rendering
  a component to embed it separately and not inside of app.vue. don't use this
  with app.vue. -->
<template>
  <v-app>
    <v-container fluid v-bind:class="{mobile: mobile}">
      <!-- <slot v-bind:mapNames="{mapName: customer, mapSecondName: site}"></slot> -->
      <!-- TODO: remove customer/site/embedded -->
      <TreeMap v-if="components.includes('tree-map')" />
      <CanopyMap v-if="components.includes('canopy-map')" />
      <ParksMap v-if="components.includes('parks-map')" />
    </v-container>
  </v-app>
</template>

<script>
import MapSetService from '@/shared/infrastructure/map-set/service';
import MapSet from '@/shared/infrastructure/map-set';
import TreeMap from '@/tree-map';
import CanopyMap from '@/canopy-map';
import ParksMap from '@/parks-map';
import {Utils} from '@/shared';

export default {
  components: {CanopyMap, ParksMap, TreeMap},
  props: ['mapName', 'mapSubName', 'components'],
  provide() {
    return {
      mapSet: this.mapSet,
      mapSetKey: this.mapSet.key(), // within mapSet
      mapName: this.mapSet.mapName(), // within mapSet
      mapSubName: this.mapSet.mapSubName(), // within mapSet
      embedded: this.embedded,
      // mobile? this would be nice to do
    };
  },
  data: () => ({
    embedded: true, // embedded if using this file
  }),
  computed: {
    // identical to hosted.vue mapSet()
    mapSet() {
      return new MapSet(this.mapName, this.mapSubName);
    },
    mobile() {
      return Utils.isMobile() || this.$vuetify.breakpoint.mobile;
    },
  },
  // this is entrypoint for embedded version of app
  created() {
    const components = this.components.split(' ');

    MapSetService.registerStoreModule(this.mapSet, components);
    MapSetService.fetchMapComponentConfigurations(this.mapSet, components);
  },
};
</script>

<style scoped lang="scss">
.container.mobile {
  height: 100%;
  overflow: hidden;
  padding-top: 0px;
  padding-bottom: 0px;
}

div {
  width: 100%;

  /* trying to address issue where maps aren't 100% width initially per https://stackoverflow.com/questions/47953419/elements-of-a-component-arent-taking-up-100-of-the-pages-width */
  div.v-application {
    width: 100%;
  }
}
</style>
